import { lazy } from 'react';

import { Loadable } from '../../../../utils';

export const Location = Loadable(lazy(() => import('../containers/LocationContainer')));
